<div class="aprova-checkbox" [class.aprova-checkbox--disabled]="disabled">
  <div class="aprova-checkbox__container">
    <input
      [id]="id"
      type="checkbox"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onInputChange($event)"
    />
    <span
      class="aprova-checkbox__checkmark"
      [style.--checkbox-color]="color"
      (click)="onInputChange($event)"
    >
      @if (checked) {
      <svg
        version="1.1"
        focusable="false"
        viewBox="0 0 24 24"
        xml:space="preserve"
      >
        <path fill="none" stroke="#fff" d="M4.1,12.7 9,17.6 20.3,6.3"></path>
      </svg>
      }
    </span>

    <label [for]="id" class="aprova-checkbox__content">
      <ng-content></ng-content>
    </label>
  </div>

  <div class="aprova-checkbox__error-box">
    <div #errorMessageRef>
      <ng-content select="[error-message]"></ng-content>
    </div>

    @if (hasError && !isErrorMessageSlotUsed) {
    <p class="aprova-checkbox__error-message">
      {{ errorMessageInternal }}
    </p>
    }
  </div>
</div>
